// extracted by mini-css-extract-plugin
export default {"root":"N7kA_zrm2n8mG3pZUuJ5","hasRatio":"ZWRrRgk0wkXUvzZOPfve","placeholder":"fjqm_OSYaFINaW3v2pG6","content":"vLUz9wKsQbocFiC3Zlvb"};